<template>
    <div>
      <v-autocomplete
        v-model="getValue"
        :items="getLineList"
        :label="$t(label)"
        @blur="$emit('blur', $event)"
        @click:clear="$emit('click:clear', $event)"
        outlined
        dense
        clearable
      />
    </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  export default {
    name: 'AutocompleteLine',
    inheritAttrs: false,    
    props: {
      label: {
        type: String,
        default: 'line'
      },
    },
    async mounted() {
      await this.getLines()
    },    
    methods: {
      ...mapActions('lineStore', {
        getLines : 'setDataToList'
      }),
    },
    computed: {
      getValue: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
      ...mapState({
        getList(_, getters) {
          return getters['lineStore/getList']
        },      
      }),
      getLineList() {
        return this.getList.filter(el => el.DESC_LINE != null).map((el) => ({
            text: el.TRADUCAO ? el.TRADUCAO : el.DESC_LINE,
            value: el.TRADUCAO
        })).sort((prev, next) => {
            return prev.text.localeCompare(next.text)
        })
      }
    },
  }
</script>